<template>
  <el-dialog title="素材审核详情" :visible.sync="dialogVisible" width="700px" @closed="handleClose">
    <el-table :data="list" style="width: 100%">
      <el-table-column property="originUrl" label="图片" width="60">
        <template slot-scope="{ row }">
          <div style="margin: 14px 0px 5px">
            <ImgUpload :width="46" :height="46" :size="100" :onlyPreview="true" :file="row.originUrl" :isSingle="true" />
          </div>
        </template>
      </el-table-column>
      <el-table-column property="materilName" label="素材名称"> </el-table-column>
      <el-table-column property="auditStatus" label="状态" width="120">
        <template slot-scope="{ row }">
          {{ auditStatusMap[row.auditStatus] }}
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button @click="handleClose">关闭</el-button>
    </template>
  </el-dialog>
</template>
  
  <script>
import ImgUpload from '@/components/Uploads/ImgUpload';
export default {
  components: {
    ImgUpload,
  },
  data() {
    return {
      dialogVisible: false,
      list: [],
      opts: {},
      auditStatusMap: {
        1: '待审核',
        2: '审核中',
        3: '审核通过',
        4: '拒绝',
      },
    };
  },
  methods: {
    method_open(opts) {
      this.opts = opts;
      this.list = opts.list;
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.opts = {};
      this.list = [];
    },
  },
};
</script>
  
  <style></style>
  